
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Products from './components/Products';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SplashScreen from '../../components/feature/SplashScreen';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaLocalBusiness = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  '@id': `${SITE_URL}/#business`,
  name: 'SouthDev Home Depot',
  url: SITE_URL,
  logo: 'https://public.readdy.ai/ai/img_res/ab6611c1-80ab-40ed-a457-2bfc514ceb18.png',
  image: 'https://static.readdy.ai/image/7e22dd63abefb8d10cd003bf2bbcd2a0/bb0f2d8a9a976362dcdf9e886ed742a6.png',
  description:
    'SouthDev Home Depot is your trusted partner for premium building materials, bathroom fixtures, flooring, and interior finishes in Davao City, Philippines.',
  telephone: '+639399398250',
  email: 'southdevhomedepo2020@gmail.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Luisa St., Corner Mangga St., Juna Subdivision Ecoland',
    addressLocality: 'Matina, Davao City',
    addressRegion: 'Davao del Sur',
    addressCountry: 'PH',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 7.0541539,
    longitude: 125.5940067,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '08:00',
      closes: '17:00',
    },
  ],
  hasMap: 'https://www.google.com/maps/dir/?api=1&destination=7.0541539,125.596587',
  priceRange: '$$',
  currenciesAccepted: 'PHP',
  paymentAccepted: 'Cash, Credit Card',
  areaServed: {
    '@type': 'City',
    name: 'Davao City',
  },
  sameAs: [],
};

const schemaWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'SouthDev Home Depot',
  description:
    'Premium building materials, bathroom fixtures, flooring, and interior finishes in Davao City.',
  publisher: {
    '@id': `${SITE_URL}/#business`,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const schemaFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Where is SouthDev Home Depot located?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'SouthDev Home Depot is located at Luisa St., Corner Mangga St., Juna Subdivision Ecoland, Matina, Davao City — near the Ecoland Bus Terminal.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the business hours of SouthDev Home Depot?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We are open Monday to Saturday, 8:00 AM to 5:00 PM.',
      },
    },
    {
      '@type': 'Question',
      name: 'What products does SouthDev Home Depot sell?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'SouthDev Home Depot offers 500+ premium building materials including flooring, structural materials, bathroom fixtures, bathroom cabinets, and interior finishes in Davao City.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I contact SouthDev Home Depot?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can reach us by phone at +63 (939) 939 8250 or by email at southdevhomedepo2020@gmail.com.',
      },
    },
  ],
};

function injectSchema(id: string, data: object) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    (el as HTMLScriptElement).type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    injectSchema('schema-local-business', schemaLocalBusiness);
    injectSchema('schema-website', schemaWebSite);
    injectSchema('schema-faq', schemaFAQ);
    return () => {
      ['schema-local-business', 'schema-website', 'schema-faq'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0F0F0F]">
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      <Navbar scrolled={scrolled} />
      <Hero />
      <Introduction />
      <Products />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
}
